import { DatePicker, Input } from "components"
import { Select, TextEditor } from "components2"
import { ContentState, convertFromHTML, EditorState } from "draft-js"
import { useFormikContext } from "formik"
import { Fragment, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useQuery } from "react-query"
import PermintaanPerubahaDataApi from "../api/PermintaanPerubahaDataApi"
import { useDropdownUrgensi } from "../hooks"

export const FormPermintaanPerubahanData = () => {
  const { values, errors, touched, setValues } = useFormikContext()

  const [textEditorState] = useState(() => {
    return EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(values.deskripsi)))
  })

  const dropdownUrgensi = useDropdownUrgensi()

  useQuery(
    ["permintaan_perubahan_data", "genereate_nomor", values.tgl_permintaan_perubahan_data_master],
    () => PermintaanPerubahaDataApi.generateNumber({ tanggal: values.tgl_permintaan_perubahan_data_master }),
    {
      enabled: Boolean(values.tgl_permintaan_perubahan_data_master) && !values.id_permintaan_perubahan_data_master,
      onSuccess: (res) => {
        setValues({
          ...values,
          no_permintaan_perubahan_data_master: res.data.data
        })
      }
    }
  )

  return (
    <Fragment>
      <Row>
        <Col>
          <DatePicker
            label="Tgl. Permintaan Pengubahan Data"
            dateFormat="dd/MM/yyyy"
            selected={
              values.tgl_permintaan_perubahan_data_master
                ? new Date(values.tgl_permintaan_perubahan_data_master)
                : ""
            }
            onChange={(date) => {
              setValues({
                ...values,
                tgl_permintaan_perubahan_data_master: date
              })
            }}
            error={
              errors.tgl_permintaan_perubahan_data_master &&
              touched.tgl_permintaan_perubahan_data_master &&
              true
            }
            errorText={errors.tgl_permintaan_perubahan_data_master}
          />
        </Col>

        <Col>
          <Input
            readOnly
            disabled
            label="No. Permintaan Pengubahan Data"
            className="d-flex flex-column"
            value={values.no_permintaan_perubahan_data_master}
          />
        </Col>

        <Col>
          <Select
            label="Urgensi"
            placeholder="Pilih urgensi"
            name="urgensi"
            options={dropdownUrgensi.data}
            onChange={async (val) =>
              setValues({
                ...values,
                urgensi: val.value,
              })
            }
            error={errors.urgensi && touched.urgensi && true}
            errorText={touched.urgensi && errors.urgensi}
          />
        </Col>
      </Row>

      <TextEditor
        label="Deskripsi"
        name="deskripsi"
        editorState={textEditorState}
        onChange={(e) => setValues(prev => ({ ...prev, deskripsi: e }))}
        height={300}
        error={Boolean(errors.deskripsi && touched.deskripsi)}
        errorText={touched.deskripsi && errors.deskripsi}
      />
    </Fragment>
  )
}